export default __webpack_public_path__ + "static/uy-b08b051236d564cea4a0c65068812b4d.svg";